function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.pdf0{fill:#E9E9E0;}\n\t.pdf1{fill:#D9D7CA;}\n\t.pdf2{fill:#CC4B4C;}\n\t.pdf3{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "pdf0",
  d: "M37,0H8C7.2,0,6.5,0.7,6.5,1.9V55c0,0.3,0.7,1,1.5,1H48c0.8,0,1.5-0.7,1.5-1V13c0-0.7-0.1-0.9-0.3-1.1 L37.6,0.3C37.4,0.1,37.2,0,37,0z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "pdf1",
  points: "37.5,0.2 37.5,12 49.3,12  "
}), /*#__PURE__*/React.createElement("path", {
  className: "pdf2",
  d: "M19.5,33.3L19.5,33.3c-0.3,0-0.7-0.1-1-0.3c-1-0.8-1.2-1.6-1.1-2.2c0.2-1.6,2.2-3.3,6-5.1 c1.5-3.3,2.9-7.4,3.8-10.8c-1-2.2-2-5-1.3-6.6c0.2-0.6,0.6-1,1.1-1.2c0.2-0.1,0.8-0.2,1-0.2c0.5,0,0.9,0.6,1.3,1 c0.3,0.4,1,1.2-0.4,6.8c1.3,2.8,3.3,5.6,5.1,7.6c1.3-0.2,2.4-0.4,3.4-0.4c1.6,0,2.5,0.4,2.9,1.1c0.3,0.6,0.2,1.3-0.4,2.2 c-0.6,0.8-1.3,1.2-2.2,1.2c-1.2,0-2.6-0.8-4.2-2.3c-2.8,0.6-6.1,1.7-8.8,2.8c-0.8,1.8-1.6,3.2-2.4,4.3 C21.3,32.7,20.4,33.3,19.5,33.3z M22.2,28.2c-2.1,1.2-3,2.2-3.1,2.7c0,0.1,0,0.3,0.4,0.7C19.7,31.6,20.6,31.2,22.2,28.2z  M35.8,23.8c0.8,0.6,1,0.9,1.5,0.9c0.2,0,0.9,0,1.2-0.4c0.1-0.2,0.2-0.3,0.2-0.4c-0.1-0.1-0.3-0.2-1.2-0.2 C37.1,23.6,36.5,23.7,35.8,23.8z M28.3,17.2c-0.7,2.5-1.7,5.1-2.7,7.6c2.1-0.8,4.4-1.5,6.5-2C30.8,21.1,29.5,19.2,28.3,17.2z  M27.7,8.7c-0.1,0-1.3,1.8,0.1,3.2C28.8,9.8,27.8,8.7,27.7,8.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "pdf2",
  d: "M48,56H8c-0.8,0-1.5-0.7-1.5-1.5V39h43v15.5C49.5,55.3,48.8,56,48,56z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "pdf3",
  d: "M17.4,53h-1.6V42.9h2.9c0.4,0,0.9,0.1,1.3,0.2s0.8,0.3,1.1,0.6c0.3,0.3,0.6,0.6,0.8,1s0.3,0.8,0.3,1.3 c0,0.5-0.1,1-0.3,1.4s-0.4,0.8-0.7,1S20.5,49,20,49.1s-0.9,0.2-1.4,0.2h-1.2L17.4,53L17.4,53z M17.4,44.2v4h1.5 c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.4-0.2,0.5-0.3c0.2-0.2,0.3-0.4,0.4-0.6s0.1-0.6,0.1-1c0-0.2,0-0.4-0.1-0.6c0-0.2-0.1-0.4-0.3-0.6 c-0.1-0.2-0.3-0.4-0.6-0.5s-0.6-0.2-1-0.2L17.4,44.2L17.4,44.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "pdf3",
  d: "M32.2,47.7c0,0.8-0.1,1.5-0.3,2.1s-0.4,1.1-0.7,1.5s-0.6,0.7-0.9,0.9s-0.7,0.4-1,0.5 c-0.3,0.1-0.6,0.2-0.9,0.2c-0.3,0-0.5,0-0.6,0h-3.8V42.9h3c0.8,0,1.6,0.1,2.2,0.4s1.2,0.6,1.6,1.1s0.7,1,1,1.5 C32.1,46.5,32.2,47.1,32.2,47.7z M27.4,51.8c1.1,0,1.9-0.4,2.4-1.1s0.7-1.7,0.7-3.1c0-0.4,0-0.8-0.1-1.2c-0.1-0.4-0.3-0.8-0.6-1.1 s-0.7-0.6-1.2-0.8s-1.1-0.3-1.9-0.3h-1v7.6C25.7,51.8,27.4,51.8,27.4,51.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "pdf3",
  d: "M36.3,44.2v3.2h4.2v1.1h-4.2V53h-1.7V42.9h6.3v1.2H36.3z"
})));

var SvgPdfFileIcon = function SvgPdfFileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pdfFile_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdfFileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf_file_icon.044a547f.svg";
export { ForwardRef as ReactComponent };